<div class="d-flex align-items-center flex-column p-5">
  <h1 class="app-heading">An error has occured.</h1>
  <span
    >An error has occured while logging you in. Please try again by clicking the button below. In case you are unable to login, please contact
    <a href="mailto:info@omniopti.eu">info@omniopti.eu</a>.</span
  >

  <button class="btn btn-primary mt-4" (click)="authService.navigateToCompanyLoginPage()">Try again</button>
</div>
